var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { createGlobalStyle } from "styled-components";
import { registerDeployBranchMiddleware } from "./utils/deploy-branch-middleware";
import { registerFacebookSignalsMiddleware, registerFacebookPixelMatchMiddleware } from "./utils/facebook-signals-middleware";
import { registerShopperErrorFilter } from "./utils/report-frontend-error";
import { registerChunkReload } from "./utils/chunk-reload";
// Inline global styles targeting #checkout-app (and #root for local dev if you want)
var CheckoutAppGlobalStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  /* BigCommerce host container */\n  #checkout-app {\n  }\n\n  /* Local dev root styling (optional, for parity) */\n  #root {\n  }\n\n  /* Optional inner layout */\n  #checkout-app *, #root * {\n    font-family: \"DM Sans\", sans-serif;\n  }\n"])));

// Grab the root div from public/index.html
var container = document.getElementById("root") ||
// local dev
document.querySelector("#checkout-app") ||
// BigCommerce host
function () {
  var el = document.createElement("div");
  el.id = "injected-root";
  document.body.appendChild(el);
  return el;
}();
if (!container) {
  throw new Error("Root container missing in index.html");
}

// Load DM Sans at runtime so it ships in the bundle and applies inside the
// BigCommerce-hosted checkout page (whose <head> we don't control). The id
// lets us confirm in DevTools that the injection ran.
var insertDmSansFont = function insertDmSansFont() {
  if (document.getElementById("code-inserted-font")) return;
  var link = document.createElement("link");
  link.id = "code-inserted-font";
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap";
  document.head.appendChild(link);
};
insertDmSansFont();
window.addEventListener("error", function (event) {
  // Prevent the default red error overlay
  event.preventDefault();
});

// Registered before React mounts so the filter is in place for anything thrown
// during the first render, not just once the app has settled.
registerShopperErrorFilter();

// Same reason: a stale tab usually fails on the first lazy import, which is
// well before the app has settled.
registerChunkReload();

// Register before React mounts so the Segment queue (incl. the
// auto-page() from public/index.html) flushes through the middleware
// once analytics.js loads.
registerDeployBranchMiddleware();
// Attach Meta _fbc/_fbp (shared from the storefront via the .vinomofo.com
// cookie scope) so the Facebook Conversions API destination can attribute
// purchases back to the ad click.
registerFacebookSignalsMiddleware();
// Add the shopper's billing identity as Facebook Pixel advanced-matching keys,
// scoped to that destination only so the PII does not leak to other Segment
// destinations.
registerFacebookPixelMatchMiddleware();
var root = createRoot(container);
root.render(/*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckoutAppGlobalStyles, null), /*#__PURE__*/React.createElement(App, null))));